document.addEventListener("turbo:load", () => {
  new MutationObserver(() => {
    document.body.classList.toggle('modal-open', (+document.body.dataset.openModals > 0));
  }).observe(document.body, { attributes: true });

	$(document).on('hide.bs.modal','.modal', function (event) {
    let body = document.querySelector('body');
    this.classList.remove('fv-modal-stack');
    body.dataset.openModals = $('.modal.fv-modal-stack').length;
	});

	$(document).on('show.bs.modal','.modal', function (event) {
    let body = document.querySelector('body');
    if ( typeof( body.dataset.openModals ) === 'undefined' ) {
      body.dataset.openModals = 0;
    }

    // if the z-index of this modal has been set, ignore.
    if (this.classList.contains('fv-modal-stack')) {
      return;
    }

    this.classList.add('fv-modal-stack');
    body.dataset.openModals = $('.modal.fv-modal-stack').length;
    $(this).css('z-index', 1090 + (10 * body.dataset.openModals));

    setTimeout(() => {
      let modalBackDrop = $('.modal-backdrop');
      modalBackDrop.not('.fv-modal-stack').css('z-index', 1070 + (10 * body.dataset.openModals));
      modalBackDrop.not('.fv-modal-stack').addClass('fv-modal-stack');
    }, 50);
	});
});